import { Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const SHARE_TITLE = "Sootrik – Digital Data Manager";
const SHARE_TEXT =
  "Sootrik Helps You Manage Digital Data Online - Event Digital Pass, ID/Certificate, Daily Order & More";

const isMobile = /Android|webOS|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent);

const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      return true;
    } catch {
      return false;
    }
  }
};

export default function ShareAppButton({ size = "sm", variant = "outline", className = "", testId = "share-app-btn" }) {
  const share = async () => {
    const url = window.location.origin;
    const full = `${SHARE_TITLE}\n${SHARE_TEXT}\n${url}`;
    if (isMobile && navigator.share) {
      try {
        await navigator.share({ title: SHARE_TITLE, text: SHARE_TEXT, url });
        return;
      } catch (e) {
        if (e?.name === "AbortError") return;
      }
    }
    const ok = await copyText(full);
    if (ok) toast.success("App link copy ho gaya — ab kahin bhi paste kar sakte hain");
    else toast.error("Copy nahi ho paya — address bar se link copy karein");
  };

  return (
    <Button type="button" size={size} variant={variant} onClick={share} data-testid={testId} className={className}>
      <Share2 className="h-4 w-4" /> Share App
    </Button>
  );
}
